import { EXTERNAL_NETWORKS } from '@/utils/networkConstants';
import OpenNaventService from './OpenNaventService';
import QuintoAndarService from './QuintoAndarService';

/**
 * Service factory for external networks
 * Returns the appropriate service instance based on network type
 * @param {string|null} outerNet - Network identifier (null for Tokko)
 * @returns {ExternalNetworkService|null} Service instance or null for Tokko properties
 */
export const getExternalNetworkService = (outerNet) => {
  if (!outerNet) {
    return null;
  }

  switch (outerNet) {
    case EXTERNAL_NETWORKS.OPENNAVENT:
      return new OpenNaventService();
    case EXTERNAL_NETWORKS.QUINTOANDAR:
      return new QuintoAndarService();
    default:
      console.warn(`Unknown external network: ${outerNet}`);
      return null;
  }
};

export { OpenNaventService, QuintoAndarService };
